// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"3974bb95","382":"46344963","402":"81642972","703":"7e2b0c4b","809":"fdbd574c","893":"7a8172af","925":"f39d6846","979":"c0dd89a7"}[chunkId] + ".chunk.js";
};